import React from 'react';
import { useTopicOverviewContext } from '../../context';
import TopicSlice from '../../../../organisms/topic_slice';
import style from '../../style.module.scss';
import { paths } from 'config/path_helpers';
import StatusMessage from '@magoosh/gre/adaptive_prep_v1/lib/status_message';

export const WritingContent: React.FC = () => {
  const { data, fetchData } = useTopicOverviewContext();

  React.useEffect(() => {
    fetchData('writing');
  }, []);

  return data.writing.length !== 0 ? (
    <>
      <h3>All Writing Topics</h3>
      <TopicSlice
        icon="Pen"
        name="Writing on the GRE"
        subheadline={
          <>
            These topics aim to prepare you to do your best on the writing section. While Magoosh is unable to
            score essays at this time, you may attend our <strong>Essay Grading Class</strong> (or watch the
            recording on-demand.)
            <br />
            <a style={{ color: style.brandSecondary }} href={paths.liveClasses()}>
              <strong>See Classes</strong>
            </a>{' '}
          </>
        }
        description={
          <>
            <strong>Did you know?</strong> The writing score is separate from the 340 possible combined score
            on math and verbal. Talk with the programs you’re interested in to see whether it is important,
            and if so, what score they recommend.
          </>
        }
        segments={data.writing[0].segments}
        subsection="writing"
      />
    </>
  ) : (
    <StatusMessage headline="One Second!" text="We are looking for writing topics" isColored={true} />
  );
};

export default WritingContent;
